__turbopack_context__.v({
  "eventDateLocation": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__eventDateLocation",
  "favoriteButton": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__favoriteButton",
  "header": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__header",
  "image": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__image",
  "imageWrapper": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__imageWrapper",
  "info": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__info",
  "singleEventCardMobileHorizontal": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__singleEventCardMobileHorizontal",
  "title": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__title",
  "titleWrapper": "SingleEventCardMobileHorizontal-module-scss-module__-CEzZq__titleWrapper",
});
